import Layout from "../../layouts";
import Content from "../../layouts/content";
import AuthContainer from "../../containers/affiliate";
import SEO from "../../components/seo";

export const Affiliate = () => {
    return (
        <Layout>
            <SEO />
            <Content fullHeight>
                <AuthContainer />
            </Content>
        </Layout>
    );
};
